import { useState } from "react";
import { Button } from "./ui/button";
import { Loader2, Upload, X } from "lucide-react";
import { fileToDataURL } from "../lib/file";

export default function ImageUploadField({ label, value, onChange, testId, accept = "image/*" }) {
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const data = await fileToDataURL(f);
      onChange(data);
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <div className="text-xs uppercase tracking-wider font-semibold mb-1">{label}</div>
      <div className="flex items-start gap-3">
        <label className="inline-flex items-center gap-2 px-3 py-2 border border-slate-300 hover:border-slate-900 cursor-pointer text-xs font-semibold">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          <span>Upload</span>
          <input type="file" accept={accept} className="hidden" onChange={handle} data-testid={testId} />
        </label>
        {value && (
          <div className="relative">
            <img src={value} alt="" className="w-20 h-20 object-cover border border-slate-200" />
            <button
              type="button"
              onClick={() => onChange("")}
              className="absolute -top-2 -right-2 bg-white border border-slate-300 rounded-full p-1 hover:bg-red-50"
            >
              <X className="w-3 h-3 text-red-600" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
